module.exports = __webpack_public_path__ + "img/hfg_of110122_07k.04ee0eae.jpg";